var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":_vm.doAction}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }